import * as React from "react";
const SvgDuplicataFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M21 8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1zm-6-6a1 1 0 0 1 1 1v3H9a3 3 0 0 0-2.995 2.824L6 9v7H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z", clipRule: "evenodd" }));
export default SvgDuplicataFill;
